/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import { SAMPLE_IMAGE } from '@/utils/sample/img';
import { v4 as uuidv4 } from 'uuid';
import { getCompany } from './functions';
import { min } from 'lodash';

export const convertOppStructure = (opp_structure) => {
  const structureArray = [];
  if (opp_structure.hybrid) structureArray.push('Hybrid');
  if (opp_structure.in_person) structureArray.push('In-Person');
  if (opp_structure.remote) structureArray.push('Remote');
  return structureArray;
};

export const convertType = (type) => {
  const typeArray = [];
  if (type.apprenticeship) typeArray.push('Apprenticeship');
  if (type.career_fair) typeArray.push('Career Fair');
  if (type.fellowship) typeArray.push('Fellowship');
  if (type.full_time) typeArray.push('Full-Time');
  if (type.internship) typeArray.push('Internship');
  if (type.learning_opp) typeArray.push('Learning Opportunity');
  if (type.part_time) typeArray.push('Part-Time');
  if (type.scholarship) typeArray.push('Scholarship');
  return typeArray;
};

export const convertIndustry = (industry) => {
  return Object.keys(industry).filter((key) => industry[key]);
};

export const COMPANY_NAME_FILTERS = async () => {
  const data = await getCompany();
  if (!data || !data.companies) {
    return [];
  }

  return data.companies.map((company) => ({
    label: company,
    value: company,
  }));
};

export const ELIGIBLE_CLASS_YEAR_FILTERS = [
  { label: 'High School Student', value: 'high_school_student' },
  { label: 'College First-Year', value: 'college_freshman' },
  { label: 'College Sophomore', value: 'college_soph' },
  { label: 'College Junior', value: 'college_junior' },
  { label: 'College Senior', value: 'college_senior' },
  { label: 'Master Student', value: 'masters_student' },
  { label: 'College Graduate', value: 'college_graduate' }, // Ensure this is correct if used
  { label: 'Open to Any', value: 'open_to_any' },
];

export const JOB_TYPE_FILTERS = [
  { label: 'Internship', value: 'internship' },
  { label: 'Part time', value: 'part_time' },
  { label: 'Full time', value: 'full_time' },
  { label: 'Learning Opportunity', value: 'learning_opp' },
  { label: 'Career Fair', value: 'career_fair' },
  { label: 'Scholarship', value: 'scholarship' },
];

export const SCHOLARSHIP_TYPE_FILTERS = [
  { label: 'Chicago Scholars Exclusive', value: 'chicago_scholars_exclusive' },
  { label: 'Chicago Scholars Prioritized', value: 'chicago_scholars_prioritized' },
  { label: 'REACH Pathways Exclusive', value: 'reach_pathways_exclusive' },
  { label: 'High School Students', value: 'high_school_students' },
  { label: 'High School Seniors', value: 'high_school_seniors' },
  { label: 'College Students', value: 'college_students' },
  { label: 'Graduate School Students', value: 'grad_school_students' },
  { label: 'Transfer Students', value: 'transfer_students' },
  { label: 'Other Scholarship Opportunities', value: 'other_scholarships' },
  { label: 'Open to All', value: 'open_to_all' },
];

export const SCHOLARSHIP_AMOUNT_FILTERS = [
  { label: '$0-$1,000', min: 0, max: 1000 },
  { label: '$1,001-$5,000', min: 1001, max: 5000 },
  { label: '$5,001-$10,000', min: 5001, max: 10000 },
  { label: '$10,000+', min: 10000, max: 100000000 },
];

export const LOCATION_FILTERS = [
  { label: 'Chicago, IL', value: 'Chicago' },
  { label: 'Los Angeles, CA', value: 'Los Angeles' },
  { label: 'Miami, FL', value: 'Miami' },
  { label: 'New York, NY', value: 'New York' },
];

export const WORK_TYPE_FILTERS = [
  { label: 'Remote', value: 'remote' },
  { label: 'In-Office', value: 'in_person' },
  { label: 'Hybrid', value: 'hybrid' },
];

export const INDUSTRY_FILTERS = [
  { label: 'Agriculture and Agribusiness', value: 'agriculture_and_agribusiness' },
  { label: 'Animal Sciences', value: 'animal_sciences' },
  { label: 'Area Studies and Cultural Studies', value: 'area_studies_and_cultural_studies' },
  { label: 'Business and Commerce', value: 'business_and_commerce' },
  { label: 'Communication and Media', value: 'communication_and_media' },
  { label: 'Computer and Information Technology', value: 'computer_and_information_technology' },
  { label: 'Criminal Justice and Public Safety', value: 'criminal_justice_and_public_safety' },
  { label: 'Education and Teaching', value: 'education_and_teaching' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'Environmental Science and Conservation', value: 'environmental_science_and_conservation' },
  { label: 'Foreign Languages and Literature', value: 'foreign_languages_and_literature' },
  { label: 'Health and Medical Services', value: 'health_and_medical_services' },
  { label: 'History and Philosophy', value: 'history_and_philosophy' },
  { label: 'Human Development and Family Studies', value: 'human_development_and_family_studies' },
  { label: 'Legal Studies and Law', value: 'legal_studies_and_law' },
  { label: 'Library Science and Information Management', value: 'library_science_and_information_management' },
  { label: 'Life Sciences and Biotechnology', value: 'life_sciences_and_biotechnology' },
  { label: 'Mathematics and Statistics', value: 'mathematics_and_statistics' },
  { label: 'Multidisciplinary Studies', value: 'multidisciplinary_studies' },
  { label: 'Nutrition and Health Sciences', value: 'nutrition_and_health_sciences' },
  { label: 'Other', value: 'other' },
  { label: 'Philosophy and Religion', value: 'philosophy_and_religion' },
  { label: 'Physical Sciences and Astronomy', value: 'physical_sciences_and_astronomy' },
  { label: 'Plant Sciences and Agronomy', value: 'plant_sciences_and_agronomy' },
  { label: 'Psychology and Behavioral Sciences', value: 'psychology_and_behavioral_sciences' },
  { label: 'Public Administration and Policy', value: 'public_administration_and_policy' },
  { label: 'Social Sciences', value: 'social_sciences' },
  { label: 'Sports, Recreation, and Leisure', value: 'sports_recreation_and_leisure' },
  { label: 'Urban Planning and Architecture', value: 'urban_planning_and_architecture' },
  { label: 'Visual and Performing Arts', value: 'visual_and_performing_arts' }
];


export const JOB_POSTS = [
  {
    uid: 123456789,
    creation_date: '2024-05-19',
    description:
      'Join our team as a Software Engineer intern and contribute to building innovative software solutions.',
    responsibilities:
      'As a Software Engineer intern, you will work closely with our development team to design, develop, and test software applications. You will have the opportunity to learn and apply various programming languages and frameworks, collaborate with cross-functional teams, and contribute to the development of cutting-edge software solutions.',
    qualifications: ['JavaScript', 'React'],
    salary: 2500,
    has_applied: true,
    bookmarked: false,
    image_url: SAMPLE_IMAGE,
    company_name: 'Company A',
    job_title: 'Software Engineer Intern',
    location: 'Chicago',
    workplace_type: 'Hybrid',
    job_type: 'Internship',
    eligible_class_year: ['College Junior', 'College Senior', 'Master Student'],
  },
  {
    uid: 123456788,
    creation_date: '2024-05-17',
    description:
      'We are looking for a talented Data Analyst intern to help us analyze and interpret data.',
    responsibilities:
      'As a Data Analyst intern, you will work with our data team to collect, analyze, and interpret data to support business decision-making. You will have the opportunity to gain hands-on experience with data analysis tools and techniques, collaborate with stakeholders to understand data requirements, and present insights and recommendations to drive business growth.',
    qualifications: ['Data Analysis', 'SQL'],
    salary: 2800,
    has_applied: false,
    bookmarked: false,
    image_url: SAMPLE_IMAGE,
    company_name: 'Company B',
    job_title: 'Data Analyst Intern',
    location: 'Los Angeles',
    workplace_type: 'Remote',
    job_type: 'Internship',
    eligible_class_year: ['College Junior', 'College Senior', 'Master Student'],
  },
  {
    uid: 123456787,
    creation_date: '2024-05-06',
    description:
      'Are you passionate about designing beautiful user interfaces? Join us as a UI/UX Designer intern.',
    responsibilities:
      'As a UI/UX Designer intern, you will work closely with our design team to create intuitive and visually appealing user interfaces. You will have the opportunity to learn and apply user-centered design principles, collaborate with developers to implement designs, and contribute to the overall user experience of our products.',
    qualifications: ['UI/UX Design', 'Adobe XD'],
    salary: 3000,
    has_applied: false,
    bookmarked: false,
    image_url: SAMPLE_IMAGE,
    company_name: 'Company C',
    job_title: 'UI/UX Designer Intern',
    location: 'Chicago',
    workplace_type: 'On-Site',
    job_type: 'Internship',
    eligible_class_year: ['College Junior', 'College Senior', 'Master Student'],
  },
  {
    uid: 123456786,
    creation_date: '2024-04-27',
    description:
      'Help us develop mobile applications as a Mobile App Developer intern.',
    responsibilities:
      'As a Mobile App Developer intern, you will work with our mobile development team to design, develop, and test mobile applications. You will have the opportunity to learn and apply mobile app development frameworks and technologies, collaborate with designers to implement UI/UX designs, and contribute to the development of user-friendly and high-performance mobile apps.',
    qualifications: ['Mobile App Development', 'Flutter'],
    salary: 2700,
    has_applied: false,
    bookmarked: false,
    image_url: SAMPLE_IMAGE,
    company_name: 'Company D',
    job_title: 'Mobile App Developer Intern',
    location: 'Los Angeles',
    workplace_type: 'Remote',
    job_type: 'Internship',
    eligible_class_year: ['College Junior', 'College Senior', 'Master Student'],
  },
  {
    uid: 123456785,
    creation_date: '2024-04-27',
    description:
      'Join our team and gain hands-on experience in Web Development at Company E.',
    responsibilities:
      'As a Web Developer intern, you will work with our web development team to design, develop, and maintain web applications. You will have the opportunity to learn and apply web development technologies and best practices, collaborate with designers to implement UI designs, and contribute to the development of responsive and user-friendly web applications.',
    qualifications: ['HTML', 'CSS', 'JavaScript'],
    salary: 2600,
    has_applied: false,
    bookmarked: false,
    image_url: SAMPLE_IMAGE,
    company_name: 'Company E',
    job_title: 'Web Developer Intern',
    location: 'Chicago',
    workplace_type: 'Hybrid',
    job_type: 'Internship',
    eligible_class_year: ['College Junior', 'College Senior', 'Master Student'],
  },
  {
    uid: 123456784,
    creation_date: '2024-04-27',
    description:
      'Are you a creative thinker with a passion for marketing? Apply now for our Marketing intern position.',
    responsibilities:
      'As a Marketing intern, you will work with our marketing team to develop and execute marketing strategies. You will have the opportunity to learn and apply marketing principles and techniques, collaborate with cross-functional teams to create marketing campaigns, and contribute to the promotion and growth of our products and services.',
    qualifications: ['Marketing Strategy', 'Social Media'],
    salary: 2900,
    has_applied: false,
    bookmarked: false,
    image_url: SAMPLE_IMAGE,
    company_name: 'Company F',
    job_title: 'Marketing Intern',
    location: 'Los Angeles',
    workplace_type: 'On-Site',
    job_type: 'Internship',
    eligible_class_year: ['College Junior', 'College Senior', 'Master Student'],
  },
];
